import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'

import { history } from "../../../appRedux/store";
import { lockVisitAPI, unlockVisitAPI } from '../../../services/locked-visits-service';

import { getVisitReportAPI, getVisitsSubmittedForTypingAPI } from '../../../services/typist-service';
import { fetchRadiologistTemplates, FETCH_VISITS_SUBMITTED_FOR_TYPING, FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR, FETCH_VISITS_SUBMITTED_FOR_TYPING_START, FETCH_VISITS_SUBMITTED_FOR_TYPING_SUCCESS, LOCK_SUBMITTED_FOR_TYPING_VISIT, LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR, LOCK_SUBMITTED_FOR_TYPING_VISIT_START, LOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, UNLOCK_SUBMITTED_FOR_TYPING_VISIT, UNLOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR, UNLOCK_SUBMITTED_FOR_TYPING_VISIT_START, UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, VIEW_SUBMITTED_FOR_TYPING_VISIT, VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, VIEW_SUBMITTED_FOR_TYPING_VISIT_START, VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, SET_FOR_TYPING_SEARCH_FILTER_AND_SORT, SET_WORKLIST_PAGINATION } from '../../actions/typist/typistWorklistAction';
import { SET_VISIT_LOCK } from '../../actions/activityAction';
import { VISIT_STATES } from '../../../constants/constants';
const getAuthUserState = (state) => state.auth.authUser;
const getRoutingLocation = (state) => state.routing.location;
// const getRisUsersState = (state) => state.auth.authUser.risUserMips;

// function* getRisUserNameForRisId(risId) {
//     try {
//         const risUsers = yield select(getRisUsersState);
//         if (risUsers.length > 0) {
//             const risUser = risUsers.find(user => user.risId === risId);
//             if (risUser) {
//                 return risUser.userName;
//             }
//             message.error("Ris user not found for ris id:" + risId);
//             return null;
//         }
//         message.error("Ris users not found!");
//         return null;
//     } catch (error) {
//         console.log(error);
//     }
// }

function* setVisitLock(visit) {

    if (visit !== null) {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: true,
                reportId: visit.reportId
            }
        })
    } else {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: false,
                reportId: null
            }
        })
    }
}

function* fetchVisitsSubmittedForTyping({ payload }) {
    try {
        yield put({ type: FETCH_VISITS_SUBMITTED_FOR_TYPING_START })
        const response = yield call(getVisitsSubmittedForTypingAPI, payload);
        if (response.success) {

            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_VISITS_SUBMITTED_FOR_TYPING_SUCCESS, visits: response.data.typWorklist });
            yield put({ type: SET_WORKLIST_PAGINATION, pagination });
            yield put({ type: SET_FOR_TYPING_SEARCH_FILTER_AND_SORT, payload: { ...payload } });
        } else {
            if (response.error) {
                yield put({ type: FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR, error: response.error })
                message.error('Failed to fetch submitted for typing visits!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR, error })
        message.error('Failed to fetch submitted for typing visits!');
    }
}

function* viewSubmittedForTypingVisit({ visit }) {
    try {
        // const risUserName = yield getRisUserNameForRisId(visit.risId);
        const { userId } = yield select(getAuthUserState);
        if (visit.state === VISIT_STATES.P) {
            yield call(viewVisit, visit);
            yield call(setVisitLock, null);
        } else if (visit.lockedBy === null) {
            yield put({ type: LOCK_SUBMITTED_FOR_TYPING_VISIT_START });
            const response = yield call(lockVisitAPI, visit.reportId);
            if (response.success) {
                yield put({ type: LOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, visit: { ...visit, lockedBy: response.response.lockedBy } });
                yield call(viewVisit, { ...visit, lockedBy: response.response.lockedBy });
                if (visit) {
                    yield call(setVisitLock, visit);
                }
            } else {
                if (response.error) {
                    yield put({ type: LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
                    message.error(response.error);
                } else {
                    yield put({ type: LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: null })
                    message.error('Failed to view visit!');
                }
                yield call(setVisitLock, null);
            }
        } else {
            if (userId === visit.lockedBy) {
                if (visit && visit.lockedBy !== null) {
                    yield call(setVisitLock, visit);
                }
                yield call(viewVisit, visit);
            } else {
                message.error('Visit is already locked by other user!');
            }
        }
    } catch (error) {
        yield put({ type: LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR, error })
        yield call(setVisitLock, null);
        message.error('Failed to view visit!');
    }
}

function* viewVisit(visit) {
    yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_START })
    const { pathname } = yield select(getRoutingLocation);
    const response = yield call(getVisitReportAPI, visit.risId, visit.reportId, visit.visitNo);
    if (response.success) {
        yield put({
            type: VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS,
            report: {
                ...response.visitReport
            }
        });
        history.push({
            pathname: '/typ/report-editor',
            state: {
                from: pathname
            }
        });
        // yield put(fetchRadiologistTemplates(visit.radiologistCode));
    } else {
        if (response.error) {
            yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
            message.error(response.error);
        } else {
            yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
            message.error('Failed to view visit!');
        }
    }
}

function* typistWorklistWatcher() {
    yield takeEvery(FETCH_VISITS_SUBMITTED_FOR_TYPING, fetchVisitsSubmittedForTyping)
    yield takeEvery(VIEW_SUBMITTED_FOR_TYPING_VISIT, viewSubmittedForTypingVisit)
}

export default function* rootSaga() {
    yield all([
        typistWorklistWatcher(),
    ]);
}
